<template>
    <div>
        <popup v-if="showRecharge" @close="closePopup" :title="rechargeTitle" :isWidth="true"
               :showHeader="!isChannelDirect" :showPopupLoading="showPopupLoading">
            <template v-if="isChannelDirect">
                <recharge-by-direct :channelKey="channelKey" :user="user"
                                    :browserInfo="browserInfo"></recharge-by-direct>
            </template>
            <template v-if="!isChannelDirect">
                <template v-if="Object.keys(channelInfo.methods).length > 1">
                    <div class="currency-select">
                        <label for="currency-select">{{ channelId }}：</label>
                        <el-select @change="changeSelMethod()" v-model="methodCurrency" clearable :placeholder="channelId ? channelId : $t('selectCurrency')" id="currency-select">
                            <el-option
                                    v-for="(item, index) in rechargeCurrency"
                                    :label="item.label"
                                    :value="item.value">
                                <span style="float: left">{{ item.label }}</span>
                                <span style="float: right; color: #8492a6; font-size: 13px">{{ item.value }}</span>
                            </el-option>
                        </el-select>
                    </div>
                </template>

                <div class="method-container" v-if="channelMethods.length > 0">
                    <div class="method-select">
                        <div class="swiper-button-prev" slot="button-prev"></div>
                        <swiper :options="methodsSwiper">
                            <swiper-slide v-for="(method, methodIndex) in channelMethods"
                                          :class="{ 'method-active': methodIndex == selectedMethodIndex }">
                                <div class="method-logo" @click="changeMethod(methodIndex)">
                                    <img :src="'../../static/img/recharge/providers/' + method.logo">
                                </div>
                                <div class="method-name">
                                    {{ method.name }}
                                </div>
                            </swiper-slide>
                        </swiper>
                        <div class="swiper-button-next" slot="button-next"></div>
                    </div>
                </div>

                <div class="method-content">
                    <recharge-by-card @close="closePopup" v-if="methodType == 'card'" :channelKey="channelKey"
                                      :methodInfo="methodInfo"
                                      :user="user" :browserInfo="browserInfo" @openLoading="showPopupLoading = true"
                                      @closeLoading="showPopupLoading = false"></recharge-by-card>

                    <recharge-by-wallet @close="closePopup" v-if="methodType == 'wallet'" :channelKey="channelKey"
                                        :methodInfo="methodInfo"
                                        :user="user" :browserInfo="browserInfo" @openLoading="showPopupLoading = true"
                                        @closeLoading="showPopupLoading = false"></recharge-by-wallet>

                    <div v-if="methodType == 'direct'" class="btn-wrapper">
                        <el-button type="primary" class="direct-buy-btn" @click="directRecharge">
                            {{ $t('buyEgPoint')}}
                        </el-button>
                    </div>
                    <recharge-by-direct v-if="showDirectRecharge" :channelKey="channelKey" :user="user"
                                        :browserInfo="browserInfo"></recharge-by-direct>
                </div>
            </template>
        </popup>
    </div>
</template>

<script>
    import Popup from '../partial/Popup.vue'
    import {swiper, swiperSlide, swiperPlugins} from 'vue-awesome-swiper'
    import RechargeByCard from './RechargeByCard.vue'
    import RechargeByWallet from './RechargeByWallet.vue'
    import RechargeByDirect from './RechargeByDirect.vue'

    export default {
        data() {
            return {
                selectedMethodIndex: 0,
                showLogin: false,
                methodCurrency: '',
                showDirectRecharge: false,
                showPopupLoading: false
            };
        },
        props: ['showRecharge', 'channelInfo', 'channelId'],
        components: {
            Popup,
            swiper,
            swiperSlide,
            RechargeByCard,
            RechargeByWallet,
            RechargeByDirect
        },
        computed: {
            rechargeTitle() {
                return this.$t('use') + this.channelInfo.name + this.$t('buyEgPoint');
            },
            isChannelDirect() {
                return Object.keys(this.channelInfo.methods) == 0;
            },
            channelKey() {
                return this.channelInfo.key;
            },
            channelMethods() {
                if (Object.keys(this.channelInfo.methods).length == 1) {
                    return this.channelInfo.methods.ALL;
                } else {
                    if (this.methodCurrency) {
                        if(this.channelInfo.methods[this.methodCurrency]){
                            return this.channelInfo.methods[this.methodCurrency];
                        }else{
                            this.methodCurrency = '';
                            return [];
                        }
                    } else {
                        return [];
                    }
                }
            },
            methodInfo() {
                 if(!(this.selectedMethodIndex < this.channelMethods.length)){
                   this.selectedMethodIndex = 0;
                 }
                if (this.channelMethods.length > 0) {
                    return this.channelMethods[this.selectedMethodIndex];
                }
                return {};
            },
            methodType() {
                if (this.methodInfo == {}) {
                    return 'direct';
                }
                if ('hasCard' in this.methodInfo || 'hasSerial' in this.methodInfo) {
                    return 'card';
                }
                if ('amount' in this.methodInfo) {
                    return 'wallet';
                }
                return 'direct';
            },
            rechargeCurrency() {
                let methodCurrency = Object.keys(this.channelInfo.methods);
                let finallyCurrency = [];
                methodCurrency.forEach(function (val, index) {
                    finallyCurrency[index] = {
                        label: this.getCurrencyName(val),
                        value: val
                    };
                }, this);
                return finallyCurrency;
            },
            methodsSwiper() {
                return {
                    slidesPerView: 5,
                    paginationClickable: true,
                    spaceBetween: 30,
                    freeMode: true,
                    preventClicks: false,
                    nextButton: '.swiper-button-next',
                    prevButton: '.swiper-button-prev'
                }
            },
            user() {
                return this.$store.state.user;
            },
            browserInfo() {
                let ua = navigator.userAgent, tem, M = ua.match(/(opera|chrome|safari|firefox|msie|trident(?=\/))\/?\s*(\d+)/i) || [];
                if (/trident/i.test(M[1])) {
                    tem = /\brv[ :]+(\d+)/g.exec(ua) || [];
                    return {name: 'IE', version: (tem[1] || '')};
                }
                if (M[1] === 'Chrome') {
                    tem = ua.match(/\bOPR|Edge\/(\d+)/);
                    if (tem != null) {
                        return {name: 'Opera', version: tem[1]};
                    }
                }
                M = M[2] ? [M[1], M[2]] : [navigator.appName, navigator.appVersion, '-?'];
                if ((tem = ua.match(/version\/(\d+)/i)) != null) {
                    M.splice(1, 1, tem[1]);
                }
                return {
                    name: M[0],
                    version: M[1]
                };
            }
        },
        methods: {
            closePopup() {
                this.selectedMethodIndex = 0;
                this.$emit('closePopup');
            },
            getCurrencyName(currencyCode) {
                return currencyCode;
            },
            changeMethod(methodIndex) {
                this.selectedMethodIndex = methodIndex;
                this.rechargeTitle = this.$t('use') + this.methodInfo.name + this.$t('buyEgPoint');
            },
            directRecharge() {
                this.$emit('close');
                this.$alert(this.$t('selectChannel'), this.$t('systemError'), {
                    confirmButtonText: this.$t('confirm'),
                });
            },
            changeSelMethod(){
                this.selectedMethodIndex = 0;
            }
        }
    }
</script>

<style lang="scss" rel="stylesheet/scss" scoped>
    @import "../../assets/scss/lib";

    .method-container {
        width: 100%;
        overflow: hidden;
        margin: 0 auto;
    }

    .currency-select {
        width: 80%;
        margin: 20px auto 0;
        @include flex-row-center;
        label {
            color: #5e6d82;
            text-align: right;
        }
        #currency-select {
            width: 60%;
        }
    }

    .swiper-container {
        width: 88%;
    }

    .swiper-button-prev, .swiper-button-next {
        position: relative;
        margin: -40px 0 0;
    }

    .method-select {
        margin-top: 25px;
        box-sizing: border-box;
        @include flex-row-center;
    }

    .swiper-slide {
        height: 100px;
        @include flex-column-center;
        &:hover {
            cursor: pointer;
        }
    }

    .method-logo {
        display: block;
        height: 70px;
        width: 100%;
        @include flex-row-center;
        border-radius: 15px;
        border: 2px solid $blue-color;
        overflow: hidden;
        img {
            display: block;
            max-height: 45px;
            max-width: 95px;
        }
    }

    .method-name {
        width: 100%;
        color: #aaa;
        font-size: 11px;
        height: 30px;
        @include flex-row-center;
        margin-top: 15px;
        text-align: center;
    }

    .method-active {
        .method-logo {
            border: 2px solid $blue-color !important;
            box-shadow: 2px 3px $blue-color;
        }
        .method-name {
            margin-top: 15px;
            color: $blue-color;
            text-align: center;
        }
    }

    .method-content {
        margin: 0 auto;
        width: 800px;
        max-height: 500px;
    }

    .btn-wrapper {
        @include flex-row-center;
        margin: 50px auto;
        .direct-buy-btn {
            width: 250px;
            height: 45px;
            font-size: 18px;
        }
    }
</style>



// WEBPACK FOOTER //
// RechargePopup.vue?4fb37d58